import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import ProductSceneCarousel from "entities/business-configurator/product-scene-carousel";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { Suspense } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { concatClassnames } from "shared/utils/concatClassnames";
import { ProfielProductImage } from "../door-options/ProfielProductImage";

interface BusinessConfigurationProductProps {
  className?: string;
}
const BusinessConfiguratorProduct = ({
  className,
}: BusinessConfigurationProductProps) => {
  const { selectedDoor, layout } = useConfigurationOptionsContext();
  if (!selectedDoor) return null;

  const isZakelijkProfielItem = zakelijkProfielCodes.includes(
    selectedDoor.code,
  );
  return (
    <section
      className={concatClassnames(
        "gg-relative lg:gg-sticky lg:gg-top-[150px] lg:gg-z-10",
        className,
      )}
    >
      <>
        <Suspense
          fallback={
            <Skeleton className="gg-col-span-12 gg-h-96 gg-w-full sm:gg-h-[33rem] md:gg-h-[39.5rem] md:gg-px-2 lg:gg-h-[30rem] xl:gg-h-[33rem] 2xl:gg-h-[39.5rem]" />
          }
        >
          {isZakelijkProfielItem ? (
            <ProfielProductImage />
          ) : (
            <ProductSceneCarousel className="gg-col-span-12" />
          )}
        </Suspense>
      </>
    </section>
  );
};
export default BusinessConfiguratorProduct;
